import React , { useCallback,useEffect,useState,useContext } from 'react';
import { Table,Card,Spin,Input,Modal,Button,message,Select,InputNumber,Popover,Row,Col} from 'antd';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import _ from "lodash";
import { APIrequest } from '../../Helpers.js'
import { parseRules } from '../Projections/Scoring'
import { UserContext } from "../../Contexts/UserContext";
// import { useReactToPrint } from 'react-to-print';
function MyDash (props) {
    const { userID } =
    useContext(UserContext);
    const { Option } = Select;
    const [teams, setTeams] = useState([]);
    const [posFilter, setPosFilter] = useState('');
    const [teamData, setTeamData] = useState([]);
    const [projections, setProjections] = useState([]);
    const [values, setValues] = useState([]);
    const [projectionsLoading, setProjectionsLoading] = useState(false);
    const [team, setTeam] = useState(null);
    const [PFFdata, setPFFdata] = useState([]);
    const [PFFteamData, setPFFteamData] = useState([]);
    const [myLeagues, setMyLeagues] = useState([]);
    const [RBmultiplier, setRBmultiplier] = useState(1);
    const [TEmultiplier, setTEmultiplier] = useState(2);
    const [WRmultiplier, setWRmultiplier] = useState(1);
    const [QBmultiplier, setQBmultiplier] = useState(1.3);
    const [curatedAssets, setCuratedAssets] = useState(null);
    const [scoringLoading, setScoringLoading] = useState(false);
    const [league, setLeague] = useState(null);
    const [assets, setAssets] = useState([]);
    const [isTierModalOpen, setIsTierModalOpen] = useState(false);
    const [sorter, setSorter] = useState("value");
    const [scoring, setScoring] = useState({"QB":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"RB":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"WR":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"TE":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0}});
    const calcPoints=(data)=>{
      const receptionPts= data.Position==='WR'?1.25:(data.Position==='TE'?1.75:1)
      const PointsPer10= (data.Position==='TE'?1.5:1)
      return (Math.round((
          data.Yards*scoring[data.Position]["Passing Yards"]+
          data.PassingTouchdowns*scoring[data.Position]["Number of Passing TDs"]+
          data.Interceptions*scoring[data.Position]["Pass Interceptions Thrown"]+
          data.Receptions*scoring[data.Position]["Receptions"]+
          data.ReceivingYards*scoring[data.Position]["Receiving Yards"]+
          data.ReceivingTouchdowns*scoring[data.Position]["Number of Receiving TDs"]+
          data.RushingTDs*scoring[data.Position]["Number of Rushing TDs"]+
          data.RushingYards*scoring[data.Position]["Rushing Yards"])*100)/100)
  }
    
    const getProjections = async ()=>{
        setProjectionsLoading(true)
        console.log("Fetching Projections")
        fetch(`/api/db/getProjections/${userID}/2022/`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data=> calcScores(data.response,1))
        .then(data => {setProjections(data);setProjectionsLoading(false)
        });
      }
      const getTeamData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getTeamPlays/${userID}/2022`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setTeamData(data.response);
        });
      }
      const getPFFData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getPFF/${userID}/2022/`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setPFFdata(data.response);
        });
      }
      const getMyLeagues = async ()=>{
        console.log("Fetching Leagues")
        const result=await APIrequest(`/api/mfl/myLeagues`)
        .then(data => {console.log(data);setMyLeagues(data.leagues.league);setLeague(data.leagues.league[0]["league_id"]);
        });
      }
      const getAssets = async ()=>{
        console.log("Fetching Leagues")
        if (league>0){
        const result=await APIrequest(`/api/mfl/assets/${league}`)
        .then(data => {console.log(data);setAssets(data)})
      return result}
      }   
      const getValues = async ()=>{
        console.log("Fetching values")
        
        const result=await APIrequest(`/api/db/values`)
        .then(data => {console.log(data);setValues(data)})
      return result
      }  
      const getLeagueRules = async ()=>{
        if (league)
        {
        setScoringLoading(true)
        console.log("Fetching Leagues")
        await APIrequest(`/api/mfl/getLeagueRules?L=${league}`)
        .then(data => {console.log(data.rules.positionRules);setScoring(parseRules(data.rules.positionRules));setScoringLoading(false);
        });}
      }

      const updateTier=async(Tier)=>{
        
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Tier)
    };
    return await fetch(`/api/db/updateTier/${userID}`,requestOptions)
  }

      const addPPG  = async (p) =>{
        return({...p,PPG:await calcPoints(p)})
      }

      const calcScores = async (proj=false,ret=0) =>{
        var temp = proj?[...proj]:[...projections]
        temp=await Promise.all(temp.map(async (p)=>await addPPG(p)))
        if (ret===1){
          console.log("temp",await temp)
          return await  temp
        }
        else{
          setProjections(await temp)
        }
        
      }

    useEffect(()=> {
        getMyLeagues();
        getValues();
    } ,[]);

    useEffect(()=> {
        getProjections();
    } ,[]);

    useEffect(()=> {
      getAssets()
      getLeagueRules()
    } ,[league]);

    useEffect(()=> {
      calcScores();
    } ,[scoring]);

    useEffect(()=> {
      compileAssets();
    } ,[assets,QBmultiplier,RBmultiplier,TEmultiplier,WRmultiplier,scoring,values]);

    useEffect(()=> {
  } ,[league]);
      
   
  
  const onLeagueChange= e => {
    setLeague(e);
};

const OptimizedLineup= (players) => {
  var lineup=[]
  
  lineup=lineup.concat(players.filter(p=>p.pos==='QB' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,1))
  lineup=lineup.concat(players.filter(p=>p.pos==='RB' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,2)) 
  lineup=lineup.concat(players.filter(p=>p.pos==='WR' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,3))
  lineup=lineup.concat(players.filter(p=>p.pos==='TE' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,2))
  lineup=lineup.concat(players.filter(p=>!lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,1))
  lineup=lineup.concat(players.filter(p=>p.pos!=='QB' && !lineup.includes(p)).sort((a,b)=>b.PPG-a.PPG).slice(0,2))
  return lineup
};

const forceArray =(obj)=>{
  if (Array.isArray(obj))
  {
    return obj
  }
  else{
    return [obj]
  }
}



  const adjustedValues=() => {
    var temp=values.map(p=>{return({...p,adjustedValue:Math.round(p.Position==='TE'?p.KTCvalue*TEmultiplier:(p.Position  ==='QB'?p.KTCvalue*QBmultiplier:p.KTCvalue))})})

  
    return temp.filter(v=>v.adjustedValue>0)
}

const compileAssets=()=>{
  const franchise=assets.find(a=>a.id===myLeagues.find(l=>l.league_id===league).franchise_id)
  if (franchise){
  setCuratedAssets({
    name:franchise.name,
  Picks:{"1st":(forceArray(franchise.futureYearDraftPicks.draftPick||[])).filter(p=>p.description.includes('Round 1')).length,
  "2nd":(forceArray(franchise.futureYearDraftPicks.draftPick||[])).filter(p=>p.description.includes('Round 2')).length,
  "3rd":(forceArray(franchise.futureYearDraftPicks.draftPick||[])).filter(p=>p.description.includes('Round 3')).length
},
Pickvalue:(forceArray(franchise.futureYearDraftPicks.draftPick||[])).filter(p=>p.description.includes('Round 1')).length*1*values.find(v=>v.player==="2023 Mid 1st")?.KTCvalue+
(forceArray(franchise.futureYearDraftPicks.draftPick||[])).filter(p=>p.description.includes('Round 2')).length*1*values.find(v=>v.player==="2023 Mid 2nd")?.KTCvalue+
(forceArray(franchise.futureYearDraftPicks.draftPick||[])).filter(p=>p.description.includes('Round 3')).length*1*values.find(v=>v.player==="2023 Mid 3rd")?.KTCvalue,
  value:franchise.players.player.map(p=>adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.adjustedValue||0).reduce((partialSum, a) => partialSum + a||0, 0),
  AgeFactor:franchise.players.player.map(p=>adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.AgeFactor*adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.adjustedValue||0).reduce((partialSum, a) => partialSum + a||0, 0)/ 
  franchise.players.player.map(p=>adjustedValues().find(v=>v.MFL_ID===parseInt(p.id))?.adjustedValue||0).reduce((partialSum, a) => partialSum + a||0, 0),
  // franchise.players.player 
  players:projections.map(
     p=>{
       const {adjustedValue,PlayerName,Position,MFL_ID,AgeFactor,ContractTier,ProductionTier}=adjustedValues().find(v=>v.MFL_ID===parseInt(p.MFL_ID))||{}; 
       return({player:PlayerName,pos:Position,myPlayer:franchise.players.player.map(p=>parseInt(p.id)).includes(p.MFL_ID)?true:false,value:adjustedValue,MFL_ID:MFL_ID,PPG:(projections.find(proj=>proj.MFL_ID===parseInt(p.MFL_ID))||{"PPG":0})["PPG"],AgeFactor:AgeFactor,ContractTier:(projections.find(proj=>proj.MFL_ID===parseInt(p.MFL_ID))||{"ContractTier":0})["ContractTier"],ProductionTier:(projections.find(proj=>proj.MFL_ID===parseInt(p.MFL_ID))||{"ProductionTier":0})["ProductionTier"]})})

})}
}
const TierCols=[
  {
    title: 'Player',
    dataIndex: 'PlayerName',
    key: 'PlayerName',
    width:100,
    sorter: (a,b) => a.PlayerName-b.PlayerName,
    render: (text, record) => {
      return (
        <div>{record.PlayerName}</div>)}
  },
  {
    title: 'Position',
    dataIndex: 'Position',
    key: 'Position',
    width:100,
    sorter: (a,b) => a.Position-b.Position,
    render: (text, record) => {
      return (
        <div>{record.Position}</div>)}
  },
  {
    title: 'Value',
    dataIndex: 'Value',
    key: 'Value',
    width:100,
    sorter: (a,b) => (b.Position==='TE'?b.KTCvalue*TEmultiplier:(b.Position  ==='QB'?b.KTCvalue*QBmultiplier:b.KTCvalue))-
    (a.Position==='TE'?a.KTCvalue*TEmultiplier:(a.Position  ==='QB'?a.KTCvalue*QBmultiplier:a.KTCvalue)),
    render: (text, record) => {
      return (
        <div>{(record.Position==='TE'?record.KTCvalue*TEmultiplier:(record.Position  ==='QB'?record.KTCvalue*QBmultiplier:record.KTCvalue))}</div>)}
  },
  {
    title: 'PPG',
    dataIndex: 'PPG',
    key: 'PPG',
    width:100,
    sorter: (a,b) => (b.PPG)-
    (a.PPG),
    render: (text, record) => {
      return (
        <div>{(record.PPG)}</div>)}
  },
  {
    title: 'ProductionTier',
    dataIndex: 'ProductionTier',
    key: 'ProductionTier',
    width:100,
    sorter: (a,b) => a.ProductionTier-b.ProductionTier,
    render: (text, record) => {
      return (
        <div>{<Select 
          allowClear={false}
          placeholder="Select Production Tier"
          style={{ width: 100, fontSize: "10px" }} 
          value={record.ProductionTier} 
          optionFilterProp={false}
          onChange={(e) => handleProductionChange(e,record.NFL_PlayerID)} >
            
          {ProductionTierOptions.map(b=>
              <Option value={b} label={b}>
                {b}
              </Option>)}
          </Select>}</div>)}
  },
  {
    title: 'ContractTier',
    dataIndex: 'ContractTier',
    key: 'ContractTier',
    width:100,
    sorter: (a,b) => a.ContractTier-b.ContractTier,
    render: (text, record) => {
      return (
        <div>{ <Select 
          allowClear={false}
          placeholder="Select Contract Tier"
          style={{ width: 50, fontSize: "10px" }} 
          value={record.ContractTier} 
          optionFilterProp={false}
           onChange={(e) => handleContractChange(e,record.NFL_PlayerID)} 
          >
            
          {ContractTierOptions.map(b=>
              <Option value={b} label={b}>
                {b}
              </Option>)}
          </Select>
          }</div>)}
  },
]
console.log(values)
const MatrixCell=(min,max,tier)=>{
  // if (allPlayers){
  //   return(curatedAssets?.players.filter(p=>p.AgeFactor>min&&p.AgeFactor<=max && (p.ProductionTier||'')===tier).map(x=><div>{x.player},{x.PPG}</div>))
  // }
  return(curatedAssets?.players.filter(p=>p.pos===(posFilter===''?p.pos:posFilter)&&p.AgeFactor>min&&p.AgeFactor<=max && (p.ProductionTier||'')===tier)
  .sort((a,b)=>b.value-a.value)
  .map(x=><div style={x.myPlayer?{backgroundColor:'yellow'}:{}}>{x.player},{x.pos},{x.PPG},{x.ContractTier},{x.value}</div>))
}
const ContractTierOptions=[0,1,1.5,2,2.5,3]
const ProductionTierOptions=['Superstar','Star','Contributor','Depth','Backup','Spec','HHG','Committee+']
const handleProductionChange=async (e,NFL_PlayerID)=>{
  var temp=[...projections]
  const ind=temp.findIndex(p=>p.NFL_PlayerID===NFL_PlayerID)
  temp[ind]["ProductionTier"]=e
  setProjections([...temp])
  await updateTier({NflPlayerID:NFL_PlayerID,ContractTier:temp[ind].ContractTier,ProductionTier:temp[ind].ProductionTier})
}

const handleContractChange=async (e,NFL_PlayerID)=>{
  var temp=[...projections]
  const ind=temp.findIndex(p=>p.NFL_PlayerID===NFL_PlayerID)
  temp[ind]["ContractTier"]=e
  setProjections([...temp])
  await updateTier({NflPlayerID:NFL_PlayerID,ContractTier:temp[ind].ContractTier,ProductionTier:temp[ind].ProductionTier})
  
}
const PlayerType = 'PLAYER';

const playersData = [
  { id: 1, name: 'Player 1', age: 'Old', production: 'Good' },
  { id: 2, name: 'Player 2', age: 'Young', production: 'Bad' },
  { id: 3, name: 'Player 3', age: 'Old', production: 'Bad' },
  { id: 4, name: 'Player 4', age: 'Young', production: 'Good' },
];

const PlayerCard = ({ player }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
      type: PlayerType,
      item: player,
      collect: (monitor) => ({
          isDragging: monitor.isDragging(),
      }),
  }), [player]);

  return (
      <Card
          ref={drag}
          style={{
              marginBottom: 8,
              opacity: isDragging ? 0.5 : 1,
              cursor: 'move',
              boxShadow: isDragging ? '0 4px 8px rgba(0, 0, 0, 0.3)' : 'none',
          }}
      >
          {player.name}
      </Card>
  );
};

const DropBox = ({ title, age, production, players, movePlayer }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
      accept: PlayerType,
      drop: (item) => {
          movePlayer(item, age, production);
      },
      collect: (monitor) => ({
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
      }),
  });

  const isActive = canDrop && isOver;

  return (
      <Col span={12}>
          <Card
              ref={drop}
              title={title}
              bordered
              style={{
                  minHeight: 200,
                  backgroundColor: isActive ? '#e6f7ff' : 'white',
                  border: isActive ? '2px dashed #1890ff' : '1px solid #d9d9d9',
                  transition: 'background-color 0.3s, border 0.3s',
              }}
          >
              {players.map(player => (
                  <PlayerCard key={player.id} player={player} />
              ))}
          </Card>
      </Col>
  );
};



const [players, setPlayers] = useState(playersData);

    const movePlayer = (player, age, production) => {
        setPlayers(prevPlayers =>
            prevPlayers.map(p =>
                p.id === player.id ? { ...p, age, production } : p
            )
        );
    };

    const filterPlayers = (age, production) => {
        return players.filter(player => player.age === age && player.production === production);
    };

    return (
        <div>
          
            <div className='flexrow'>
        Select League:  
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '300px' }}
          value={league}
          onChange={(e)=>onLeagueChange(e)}
          optionLabelProp="label"
        >
          {myLeagues.map(b=>
          <Option value={b.league_id} label={b.name}>
              <div>{b.name}</div>
          </Option>)}
        </Select>
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '300px' }}
          value={posFilter}
          onChange={(e)=>setPosFilter(e)}
          optionLabelProp="label"
        >
          {['','QB','WR','RB','TE'].map(b=>
          <Option value={b} label={b}>
              <div>{b}</div>
          </Option>)}
        </Select>
        <Button onClick={()=>setIsTierModalOpen(true)}>Tiers</Button>
          <Modal width='2000px' visible={isTierModalOpen} onOk={()=>setIsTierModalOpen(false)} onCancel={()=>setIsTierModalOpen(false)}>
          
          <Table dataSource={projections.filter(p=>p.Position===(posFilter===''?p.Position:posFilter)).sort((a,b)=>
          (b.Position==='TE'?b.KTCvalue*TEmultiplier:(b.Position  ==='QB'?b.KTCvalue*QBmultiplier:b.KTCvalue))-
          (a.Position==='TE'?a.KTCvalue*TEmultiplier:(a.Position  ==='QB'?a.KTCvalue*QBmultiplier:a.KTCvalue))
          )}
        columns={TierCols}
        scroll={{ x: 800, y:  'max-content' }} />
          </Modal>
        </div>
        <DndProvider backend={HTML5Backend}>
            <Row gutter={16}>
                <DropBox title="Old & Good" age="Old" production="Good" players={filterPlayers('Old', 'Good')} movePlayer={movePlayer} />
                <DropBox title="Old & Bad" age="Old" production="Bad" players={filterPlayers('Old', 'Bad')} movePlayer={movePlayer} />
            </Row>
            <Row gutter={16} style={{ marginTop: 16 }}>
                <DropBox title="Young & Good" age="Young" production="Good" players={filterPlayers('Young', 'Good')} movePlayer={movePlayer} />
                <DropBox title="Young & Bad" age="Young" production="Bad" players={filterPlayers('Young', 'Bad')} movePlayer={movePlayer} />
            </Row>
        </DndProvider>
        {/* <Row justify="space-evenly">
          <Col span={6} className='flexcol'>Potential Stud 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'Superstar')}
          </div>
          </Col>
          <Col span={6}>Young Stud
          <div className='MatrixCell'>{
            MatrixCell(25,50,'Superstar')}
          </div>
          </Col>
          <Col span={6}>Prime Stud
          <div className='MatrixCell'>{
            MatrixCell(50,75,'Superstar')}
          </div>
          </Col>
          <Col span={6}>Vet Stud
          <div className='MatrixCell'>{
            MatrixCell(75,100,'Superstar')}
          </div>
          </Col>


          <Col span={6} className='flexcol'>Potential Star 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'Star')}
          </div>
          </Col>
          <Col span={6}>Young Star
          <div className='MatrixCell'>{
            MatrixCell(25,50,'Star')}
          </div>
          </Col>
          <Col span={6}>Prime Star
          <div className='MatrixCell'>{
            MatrixCell(50,75,'Star')}
          </div>
          </Col>
          <Col span={6}>Vet Star
          <div className='MatrixCell'>{
            MatrixCell(75,100,'Star')}
          </div>
          </Col>

          <Col span={6} className='flexcol'>Potential Contributor 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'Contributor')}
          </div>
          </Col>
          <Col span={6}>Young Contributor
          <div className='MatrixCell'>{
            MatrixCell(25,50,'Contributor')}
          </div>
          </Col>
          <Col span={6}>Prime Contributor
          <div className='MatrixCell'>{
            MatrixCell(50,75,'Contributor')}
          </div>
          </Col>
          <Col span={6}>Vet Contributor
          <div className='MatrixCell'>{
            MatrixCell(75,100,'Contributor')}
          </div>
          </Col>

          <Col span={6} className='flexcol'>Potential Depth 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'Depth')}
          </div>
          </Col>
          <Col span={6}>Young Depth
          <div className='MatrixCell'>{
            MatrixCell(25,50,'Depth')}
          </div>
          </Col>
          <Col span={6}>Prime Depth
          <div className='MatrixCell'>{
            MatrixCell(50,75,'Depth')}
          </div>
          </Col>
          <Col span={6}>Vet Depth
          <div className='MatrixCell'>{
            MatrixCell(75,100,'Depth')}
          </div>
          </Col>

          <Col span={6} className='flexcol'>Potential HHG 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'HHG')}
          </div>
          </Col>
          <Col span={6}>Young HHG
          <div className='MatrixCell'>{
            MatrixCell(25,50,'HHG')}
          </div>
          </Col>
          <Col span={6}>Prime HHG
          <div className='MatrixCell'>{
            MatrixCell(50,75,'HHG')}
          </div>
          </Col>
          <Col span={6}>Vet HHG
          <div className='MatrixCell'>{
            MatrixCell(75,100,'HHG')}
          </div>
          </Col>

          <Col span={6} className='flexcol'>Potential Spec 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'Spec')}
          </div>
          </Col>
          <Col span={6}>Young Spec
          <div className='MatrixCell'>{
            MatrixCell(25,50,'Spec')}
          </div>
          </Col>
          <Col span={6}>Prime Spec
          <div className='MatrixCell'>{
            MatrixCell(50,75,'Spec')}
          </div>
          </Col>
          <Col span={6}>Vet Spec
          <div className='MatrixCell'>{
            MatrixCell(75,100,'Spec')}
          </div>
          </Col>

          <Col span={6} className='flexcol'>Potential Backup 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'Backup')}
          </div>
          </Col>
          <Col span={6}>Young Backup
          <div className='MatrixCell'>{
            MatrixCell(25,50,'Backup')}
          </div>
          </Col>
          <Col span={6}>Prime Backup
          <div className='MatrixCell'>{
            MatrixCell(50,75,'Backup')}
          </div>
          </Col>
          <Col span={6}>Vet Backup
          <div className='MatrixCell'>{
            MatrixCell(75,100,'Backup')}
          </div>
          </Col>

          <Col span={6} className='flexcol'>Potential Committee+ 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'Committee+')}
          </div>
          </Col>
          <Col span={6}>Young Committee+
          <div className='MatrixCell'>{
            MatrixCell(25,50,'Committee+')}
          </div>
          </Col>
          <Col span={6}>Prime Committee+
          <div className='MatrixCell'>{
            MatrixCell(50,75,'Committee+')}
          </div>
          </Col>
          <Col span={6}>Vet Committee+
          <div className='MatrixCell'>{
            MatrixCell(75,100,'Committee+')}
          </div>
          </Col>

          <Col span={6} className='flexcol'>Potential '' 
          <div className='MatrixCell'>{
            MatrixCell(-1,25,'')}
          </div>
          </Col>
          <Col span={6}>Young 
          <div className='MatrixCell'>{
            MatrixCell(25,50,'')}
          </div>
          </Col>
          <Col span={6}>Prime 
          <div className='MatrixCell'>{
            MatrixCell(50,75,'')}
          </div>
          </Col>
          <Col span={6}>Vet 
          <div className='MatrixCell'>{
            MatrixCell(75,100,'')}
          </div>
          </Col>
        </Row> */}
       
        
        
      
      
        
        </div>
        
        )
        
    }

    export default MyDash;


